import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { SUBFAMILIAS_LISTA } from 'constants/codigosTransacciones'

import ListaPage from './lista'

export default function SubFamiliasPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${SUBFAMILIAS_LISTA}`} component={ListaPage} />
      </Switch>
    </Suspense>
  )
}
